// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DyQU","icon":"styles_icon__1NZ-Y"};